var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
/*
Provider which access data from localstorage
*/
export var localStorageProvider = function (key) { return function (next) { return __awaiter(_this, void 0, void 0, function () {
    var conf;
    return __generator(this, function (_a) {
        try {
            conf = localStorage.getItem(key);
            return [2 /*return*/, conf ? JSON.parse(conf) : next()];
        }
        catch (e) {
            return [2 /*return*/, next()];
        }
        return [2 /*return*/];
    });
}); }; };
/*
Provider which accesses data from a specific dom element

This expects that the dom element is a script tag with type application/json
So that the browser innerHTML property returns the unparsed json text.
*/
export var domProvider = function (id) { return function (next) { return __awaiter(_this, void 0, void 0, function () {
    var elem;
    return __generator(this, function (_a) {
        elem = document.getElementById(id);
        return [2 /*return*/, elem ? JSON.parse(elem.innerHTML) : next()];
    });
}); }; };
/*
Provides data from a static object
*/
export var staticProvider = function (data) { return function (_) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, data];
}); }); }; };
/*
Provider which handles caching of other data returned from other providers.
Also supports optional invalidation through the Invalidator protocol
*/
export var cacheProvider = function (cacheTime, invalidator) {
    if (cacheTime === void 0) { cacheTime = 600; }
    var data = null;
    var expires = null;
    if (invalidator) {
        invalidator.onInvalidation(function () { return (data = null); });
    }
    return function (next) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (data && expires && expires >= Date.now()) {
                        return [2 /*return*/, data];
                    }
                    return [4 /*yield*/, next()];
                case 1:
                    data = _a.sent();
                    expires = Date.now() + cacheTime * 1000;
                    return [2 /*return*/, data];
            }
        });
    }); };
};
/*
Factory for using providers
Handles configuring multiple providers and running all of their provide methods.

Example usage

let factory = new DataFactory<T>()
    .withProvider(cacheProvider())
    .withProvider(localStorageProvider('test'))
    .withProvider(domProvider('myData'))
*/
var DataFactory = /** @class */ (function () {
    function DataFactory() {
        this.providers = [];
    }
    DataFactory.prototype.withProvider = function (provider) {
        this.providers.push(provider);
        return this;
    };
    DataFactory.prototype.result = function () {
        // Take a copy of the array so that shift does not break the factory.
        var innerProviders = this.providers.slice();
        var next = function () {
            var prov = innerProviders.shift();
            if (!prov) {
                return Promise.reject('Cannot load config.');
            }
            return prov(next);
        };
        return next();
    };
    return DataFactory;
}());
export { DataFactory };
export default DataFactory;
//# sourceMappingURL=data.js.map